"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffectLayer = exports.SingleEffectLayer = void 0;
const pixi_js_1 = require("pixi.js");
const inversify_1 = require("inversify");
const SymbolClasses_1 = require("../../Utils/SymbolClasses");
const InfoEffect_1 = require("../../Common/InfoObject/InfoEffect");
const GameState_1 = require("../../Core/GameState");
const Utils_1 = require("../../Utils/Utils");
const Constants_1 = require("../../Core/Constants");
const GameConfig_1 = require("../../Core/GameConfig");
class SingleEffectLayer extends pixi_js_1.Container {
    constructor(info, textures, initScale) {
        super();
        this.info = info;
        this.textures = textures;
        this.initScale = initScale;
        this.pool = new Utils_1.ObjectPool();
        this.pool.newObj = () => {
            const eff = new InfoEffect_1.InfoEffect(this.info, this.textures);
            eff.scale.set(this.initScale);
            this.addChild(eff);
            return eff;
        };
        this.pool.beforeSave = e => (e.visible = false);
    }
    update(dt) {
        for (let i = 0; i < this.children.length; i++) {
            const x = this.children[i];
            if (x instanceof InfoEffect_1.InfoEffect) {
                x.update(dt);
                if (x.visible && x.allAnimEnd()) {
                    this.pool.save(x);
                }
            }
        }
    }
    setEffect(x, y) {
        const e = this.pool.get();
        e.setPosition(x, y);
        e.resetAnim();
        e.visible = true;
    }
    setTrackedEffect(tracker) {
        const e = this.pool.get();
        const pupdate = e.update;
        e.update = dt => {
            if (!e.visible)
                return;
            const t = tracker();
            if (!t.visible) {
                e.update = pupdate;
                e.stopEmit();
                return;
            }
            e.setPosition(t.x, t.y);
            pupdate.call(e, dt);
        };
        const tr = tracker();
        e.setPosition(tr.x, tr.y);
        e.resetAnim();
        e.visible = true;
    }
}
exports.SingleEffectLayer = SingleEffectLayer;
function GetSlidePos(note, musicTime) {
    const i = note.nextJudgeIndex || 1;
    const n1 = note.notes[i - 1];
    const n2 = note.notes[i];
    return Utils_1.ratio(n1.time, n2.time, musicTime, Constants_1.LaneCenterXs[n1.lane], Constants_1.LaneCenterXs[n2.lane]);
}
let EffectLayer = class EffectLayer extends pixi_js_1.Container {
    constructor(resources, state, events, config) {
        super();
        const info = resources.effect.data.info;
        const textures = resources.effect.textures;
        const tap = new SingleEffectLayer(info.tap, textures, config.noteScale);
        const single = new SingleEffectLayer(info.single, textures, config.noteScale);
        const flick = new SingleEffectLayer(info.flick, textures, config.noteScale);
        const slide = new SingleEffectLayer(info.slide, textures, config.noteScale);
        const fullcombo = new SingleEffectLayer(info.fullcombo, textures, config.noteScale);
        const slides = new Set();
        state.on.judge.add((remove, n) => {
            if (n.judge === "miss") {
                if ("parent" in n) {
                    slides.delete(n.parent);
                }
                return;
            }
            if (n.type === "flick" || n.type === "flickend") {
                flick.setEffect(Constants_1.LaneCenterXs[n.lane], Constants_1.LaneBottomY);
            }
            else {
                single.setEffect(Constants_1.LaneCenterXs[n.lane], Constants_1.LaneBottomY);
            }
            if (n.type !== "single" && n.type !== "flick") {
                if (slides.has(n.parent)) {
                    if (n.type === "slideend" || n.type === "flickend")
                        slides.delete(n.parent);
                }
                else {
                    slides.add(n.parent);
                    slide.setTrackedEffect(() => {
                        const p = n.parent;
                        const mt = state.on.musicTimeUpdate.prevArgs[0].visualTime;
                        const visible = p.nextJudgeIndex < p.notes.length && slides.has(p) && Utils_1.findex(p.notes, -1).time >= mt;
                        return {
                            x: (visible && GetSlidePos(p, mt)) || 0,
                            y: Constants_1.LaneBottomY,
                            visible,
                        };
                    });
                }
            }
        });
        state.on.emptyTap.add((remove, l) => {
            if (0 <= l && l <= 6)
                tap.setEffect(Constants_1.LaneCenterXs[l], Constants_1.LaneBottomY);
        });
        state.on.fullCombo.add(() => {
            fullcombo.setEffect(Constants_1.LayerWidth / 2, Constants_1.LayerHeight / 2);
        });
        events.Update.add((remove, dt) => {
            if (!this.parent)
                return remove();
            if (state.paused)
                return;
            for (const x of this.children) {
                if (x instanceof SingleEffectLayer) {
                    x.update(dt);
                }
            }
        });
        this.addChild(tap, single, flick, slide, fullcombo);
    }
};
EffectLayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [SymbolClasses_1.Resources, GameState_1.GameState, SymbolClasses_1.GlobalEvents, GameConfig_1.GameConfig])
], EffectLayer);
exports.EffectLayer = EffectLayer;
//# sourceMappingURL=EffectLayer.js.map